// extracted by mini-css-extract-plugin
module.exports = {"pillInfo":"DetailPill_pillInfo__1m7Lm","pillsWrapper":"DetailPill_pillsWrapper__2ozqQ"};